module.exports = __webpack_public_path__ + "img/loginMain.a509ada7.png";